// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2OESs","author":"Table_author__3ysW8","authorImage":"Table_authorImage__1dDHG","unreadRow":"Table_unreadRow__2KKDe"};